/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim
* Licensed under MIT
* Coded by Creative Tim
=========================================================
*/

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loginApi } from "../api/auth.api";
import { setToken, setUserData, clearToken, clearUserData } from "../utils/token";
import { Row, Col, Typography, Form, Input, Switch, Button, notification } from "antd";
import logo from "../assets/images/logo.png"; // your logo

const { Title } = Typography;

export default class SignIn extends Component {
  // Helper method to open notifications
  openNotification = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
      placement: 'topRight',
      duration: 4.5,
    });
  };

  render() {
    // Remember me switch handler
    const onChange = (checked) => {
      console.log(`Switch to ${checked}`);
    };

    // Form submit
    const onFinish = async (values) => {
      try {
        const res = await loginApi(values);
        
        // Adjust these paths based on your actual API response structure
        const token = res.data?.data?.tokens?.access_token || res.data?.token;
        const userData = res.data?.data?.user || res.data?.user;
        const userRole = userData?.role;

        if (!token) throw new Error("Access token not found");
        if (!userData) throw new Error("User data not found");

        // Check if user role is 'user' - deny access
        if (userRole === 'user' || userRole === 'User') {
          this.openNotification(
            'error',
            'Access Denied',
            'You do not have permission to access this admin dashboard. Please contact administrator.'
          );
          return; // Stop execution - don't set token or redirect
        }

        // For allowed roles (admin, super_admin, manager, etc.), proceed with login
        setToken(token); // store in localStorage and cookie
        setUserData(userData); // store user data

        // Show success notification
        this.openNotification(
          'success',
          'Login Successful',
          `Welcome back, ${userData?.name || userData?.email || 'Admin'}!`
        );

        // Small delay to show notification before redirect
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 1000);

      } catch (err) {
        console.log(err);
        const errorMessage = err.response?.data?.message || err.message || "Login failed";
        
        // Clear any existing tokens/user data on failed login
        clearToken();
        clearUserData();
        
        // Show error notification
        this.openNotification(
          'error',
          'Login Failed',
          errorMessage
        );
      }
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f2f5" }}>
        <Col xs={24} sm={18} md={12} lg={8} style={{ padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderRadius: 8, backgroundColor: "#fff" }}>
          
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: 30 }}>
            <img src={logo} alt="Logo" style={{ height: 60 }} />
          </div>

          {/* Titles */}
          <Title level={2} style={{ textAlign: "center", marginBottom: 10 }}>Admin Sign In</Title>
          <Title level={5} style={{ textAlign: "center", fontWeight: 400, color: "#6c757d", marginBottom: 30 }}>
            Enter your credentials to access admin dashboard
          </Title>

          {/* Form */}
          <Form
            name="signin"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: 'email', message: "Please enter a valid email!" }
              ]}
            >
              <Input placeholder="admin@example.com" size="large" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
                { min: 6, message: "Password must be at least 6 characters!" }
              ]}
            >
              <Input.Password placeholder="••••••••" size="large" />
            </Form.Item>

            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Switch defaultChecked onChange={onChange} /> <span style={{ marginLeft: 8 }}>Remember me</span>
            </Form.Item>

            <Form.Item style={{ marginTop: 24 }}>
              <Button type="primary" htmlType="submit" style={{ width: "100%", height: 40, fontSize: 16 }}>
                SIGN IN
              </Button>
            </Form.Item>

            <div style={{ textAlign: "center", marginTop: 16 }}>
              <Link to="/forgot-password" style={{ color: "#1890ff" }}>Forgot password?</Link>
            </div>
          </Form>
        </Col>
      </div>
    );
  }
}